import { PartnerTierListType } from "../../../../../redux/slices/partner-program/Types";

export type PartnerTierFilterOption = {
  label: string;
  value: string;
};

export const buildPartnerTierFilterOptions = (
  partnerTierList: PartnerTierListType
): PartnerTierFilterOption[] =>
  partnerTierList.map((tier) => ({
    label: tier.tier_name,
    value: String(tier.ID),
  }));

export const buildPartnerTierNameById = (
  partnerTierList: PartnerTierListType
): Map<string, string> =>
  new Map(
    partnerTierList.map((tier) => [String(tier.ID), tier.tier_name])
  );
